<template>

	<a-card :bordered="false" class="widget-1">
		<a-statistic
			:title="title"
			:value="isNumeric ? value : 0"
			:prefix="isNumeric ? prefix : ''"
			:suffix="isNumeric ? suffix : ''"
			:precision="0"
			class="text-success"
			:class="'text-' + status"
		>
			<template v-if="!isNumeric" #formatter>
				{{ prefix }}{{ value }}{{ suffix }}
			</template>
		</a-statistic>
		<div class="icon" v-html="icon"></div>
	</a-card>

</template>

<script>

	export default ({
		props: {
			title: {
				type: String,
				default: "",
			},
			value: {
				type: [Number, String],
				default: 0,
			},
			prefix: {
				type: String,
				default: "",
			},
			suffix: {
				type: String,
				default: "",
			},
			icon: {
				type: String,
				default: "",
			},
			status: {
				type: String,
				default: "success",
			},
		},
		computed: {
			isNumeric() {
				return typeof this.value === 'number' && !isNaN(this.value);
			}
		},
		data() {
			return {
			}
		},
	})

</script>